// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useQueryWithOptions } from '../../other/useQueryWithOptions';

export const useHasDelegatedBatchedMarkersProxy = (
  operator?: string,
  provider?: string,
): UseQueryResult<boolean, string> => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOptions({
    queryKey: ['queryDelegatedBatchedMarkersProxy', operator, provider],
    enabled: !!operator && !!provider,
    queryFn: async (_, options) => {
      if (!operator || !provider) {
        return false;
      }

      const proxy = await ledgerApi.queryDelegatedBatchedMarkersProxy(options, operator, provider);
      return proxy !== null;
    },
  });
};

export default useHasDelegatedBatchedMarkersProxy;
